import React, { useEffect, useState } from 'react';

// Drop photos into this folder. Numeric prefixes control their display order.
const files = require.context('../images/slideshow', false, /\.(avif|webp|png|jpe?g)$/i);
const photos = files.keys().sort((a, b) => a.localeCompare(b, undefined, { numeric: true })).map(path => ({
  src: files(path),
  alt: path.replace(/^\.\//, '').replace(/\.[^.]+$/, '').replace(/^\d+[-_ ]*/, '').replace(/[-_]/g, ' '),
}));
export const hasPhotos = photos.length > 0;

export default function PhotoSlideshow() {
  const [active, setActive] = useState(0);
  const [reducedMotion, setReducedMotion] = useState(() => window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  useEffect(() => {
    const query = window.matchMedia('(prefers-reduced-motion: reduce)');
    const update = () => setReducedMotion(query.matches);
    query.addEventListener('change', update);
    return () => query.removeEventListener('change', update);
  }, []);
  useEffect(() => {
    if (photos.length < 2 || reducedMotion) return;
    const timer = window.setInterval(() => setActive(index => (index + 1) % photos.length), 5000);
    return () => window.clearInterval(timer);
  }, [reducedMotion]);
  if (!hasPhotos) return null;
  return <section className="hero-art slideshow" aria-label="Karma Kreamery photos" aria-roledescription="carousel">
    <div className="photo-frame">{photos.map((photo, index) => <img key={photo.src} src={photo.src} alt={photo.alt || 'Karma Kreamery'} className={`slide${active === index ? ' is-active' : ''}`} aria-hidden={active !== index} />)}</div>
  </section>;
}
